import { Select } from 'antd';
import { SelectValue } from "antd/lib/select";
import { observer } from 'mobx-react';
import React, { useEffect } from "react";
import TagsStore from "../../../stores/common/tags-filter";
import './style.css';

const { Option } = Select;

const TagsFilter: React.FC<{data: TagsStore}> = ({data}) => {

    const handleChange = (value: SelectValue) => {
        data.selectItem(value as string[]);
    }

    useEffect(() => { data.loadDictionary(); }, [data]);

    return (
        <Select
            mode="multiple"
            placeholder="метки"
            optionLabelProp="label"
            onChange={handleChange}
            value={data.selectedItems}
            className="filter__item"
        >
            {data.items?.map((i) => <Option key={i.id} value={i.id} label={i.name}>{i.name}</Option>)}
        </Select>
    );
};

export default observer(TagsFilter);